<div class="wrapper" #dropdownEl>
  <div class="title">
    {{title}}
    <button class="btn btn-link p-0 mobile-btn-close" (click)="closeClick($event)">
      <i class="fa fa-close"></i>
    </button>
  </div>
  <button [ngClass]="{'hidden' : !valuesChange}" (click)="rangeChange($event)"
    class="btn btn-secondary btn-sm applyBtn pull-xs-right">Apply</button>
  <div class="text-xs-center value-inputs" (click)="$event.stopPropagation()">
    <input #minField class="pull-xs-left" [(ngModel)]="fromValue" (keydown.enter)="rangeChange($event)" type="number"
      step="{{step}}" />&nbsp;-&nbsp;
    <input class="pull-xs-right" [(ngModel)]="toValue" (keydown.enter)="rangeChange($event)" type="number"
      step="{{step}}" />
  </div>
  <div class="inventory-slider idle" (click)="$event.stopPropagation()">
    <input #rangeslider class="inventory-slider" type="text" name="example_name" value="" />
  </div>
</div>